import { Descriptions, Drawer, Table, Tag } from 'antd';
import dayjs from 'dayjs';
import type {
  AdminCommerceMembershipDetail,
  AdminCommerceOrderSummary,
} from '@/types';

interface MembershipDrawerProps {
  open: boolean;
  loading: boolean;
  detail: AdminCommerceMembershipDetail | null;
  onClose: () => void;
}

function displayTime(value: string) {
  if (!value) {
    return '-';
  }
  return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
}

export function MembershipDrawer({
  open,
  loading,
  detail,
  onClose,
}: MembershipDrawerProps) {
  const membership = detail?.membership;
  return (
    <Drawer
      title="用户会员周期"
      width={720}
      open={open}
      loading={loading}
      onClose={onClose}
    >
      {membership?.exists ? (
        <Descriptions bordered size="small" column={2}>
          <Descriptions.Item label="用户 ID">
            {membership.userId}
          </Descriptions.Item>
          <Descriptions.Item label="会员等级">
            {membership.tierKey}
          </Descriptions.Item>
          <Descriptions.Item label="周期">
            {membership.billingPeriod}
          </Descriptions.Item>
          <Descriptions.Item label="状态">
            <Tag>{membership.status}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="当前周期开始">
            {displayTime(membership.currentPeriodStart)}
          </Descriptions.Item>
          <Descriptions.Item label="当前周期结束">
            {displayTime(membership.currentPeriodEnd)}
          </Descriptions.Item>
          <Descriptions.Item label="来源订单">
            {membership.sourceOrderNo || '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Stripe Subscription">
            {membership.stripeSubscriptionId || '-'}
          </Descriptions.Item>
        </Descriptions>
      ) : (
        <div className="text-text-muted">当前没有会员</div>
      )}

      <h3 className="mb-3 mt-6 text-base font-semibold">订阅订单时间线</h3>
      <Table<AdminCommerceOrderSummary>
        rowKey="orderNo"
        loading={loading}
        pagination={false}
        dataSource={detail?.subscriptionOrders ?? []}
        columns={[
          { title: '订单号', dataIndex: 'orderNo' },
          { title: '类型', dataIndex: 'orderType' },
          { title: 'SKU', dataIndex: 'skuCode' },
          { title: '状态', dataIndex: 'status' },
          {
            title: '支付时间',
            dataIndex: 'paidAt',
            render: (value: string) => displayTime(value),
          },
        ]}
        scroll={{ x: 'max-content' }}
      />
    </Drawer>
  );
}
